import { ContentIcon } from './shared/ContentIcon';
import { ContentType } from 'constants/types';
import React from 'react';
import CurrencyInput from 'react-currency-input';
import currency from 'currency.js';
import { connect } from 'react-redux';
import { groupsByIdSelector } from 'selectors/groups';

class JournalEntryItemFormBase extends React.PureComponent {
  handleCreditChange = (event, maskedValue, floatValue) =>
    this.props.onChange(this.props.id, floatValue, 'credit');
  handleDebitChange = (event, maskedValue, floatValue) =>
    this.props.onChange(this.props.id, floatValue, 'debit');
  handleRemove = () => this.props.onRemove(this.props.id);

  render() {
    const { item, groupsById, settings } = this.props;
    const cgroupId =
      item.contentId in groupsById && groupsById[item.contentId].cgroupId;

    const formatterConfig = {
      separator: settings.thousandsSeparator,
      decimal: settings.decimalSeparator,
    };

    return (
      <tr>
        <td className="description">
          <ContentIcon
            isGroup={item.contentType === ContentType.group}
            cgroupId={cgroupId}
          />
          {item.contentDescription}
        </td>
        <td className="debit">
          <CurrencyInput
            value={currency(item.debit, formatterConfig).format()}
            onChangeEvent={this.handleDebitChange}
            selectAllOnFocus={true}
            allowNegative={true}
            decimalSeparator={settings.decimalSeparator}
            thousandSeparator={settings.thousandsSeparator}
          />
        </td>
        <td className="credit">
          <CurrencyInput
            value={currency(item.credit, formatterConfig).format()}
            onChangeEvent={this.handleCreditChange}
            selectAllOnFocus={true}
            allowNegative={true}
            decimalSeparator={settings.decimalSeparator}
            thousandSeparator={settings.thousandsSeparator}
          />
        </td>
        <td className="remove">
          <button type="button" onClick={this.handleRemove}>
            ×
          </button>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    groupsById: groupsByIdSelector(state),
  };
}

export const JournalEntryItemForm = connect(mapStateToProps)(
  JournalEntryItemFormBase
);
